import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig, RestActionType } from '@intelliarts/ia-react-template';

import authConfig, { PROJECTS_MENU_GROUP } from '../../../config/authConfig';
import { PROJECTS_PAGE_LOCALE_PATH } from '../../Employee/locales';
import { projectActions, ProjectsStore } from '../store/projectsStore';

export const ProjectsRoutes = {
  default: 'projects',
};

export const ProjectsPageConfig: ReactPageConfig = {
  name: `${PROJECTS_PAGE_LOCALE_PATH}.pageConfig.name`,
  path: ProjectsRoutes.default,
  allowedRoles: [authConfig.roles.ADMIN],
  component: lazy(() => import('../components/ProjectsPage')),
  storeDependencies: [
    { store: ProjectsStore, onContainerInitAction: projectActions[RestActionType.GET] },
  ],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/FolderOutlined')),
    label: `${PROJECTS_PAGE_LOCALE_PATH}.pageConfig.label`,
    group: PROJECTS_MENU_GROUP,
  }),
};
